import environment from 'config/environment'

export const DEV_INSPECTOR_STORAGE_KEY = 'debug:devInspector'

function readStorageOverride(): boolean | undefined {
  try {
    const stored = localStorage.getItem(DEV_INSPECTOR_STORAGE_KEY)
    if (stored === '1' || stored === 'true') {
      return true
    }
    if (stored === '0' || stored === 'false') {
      return false
    }
  } catch {
    // ignore
  }
  return undefined
}

function readEnvOverride(): boolean | undefined {
  const env = import.meta.env.VITE_APP_DEV_INSPECTOR as string | undefined
  if (env === 'true' || env === '1') {
    return true
  }
  if (env === 'false' || env === '0') {
    return false
  }
  return undefined
}

/** ON par défaut en local/development ; override via localStorage ou VITE_APP_DEV_INSPECTOR. */
export function isDevInspectorEnabled(): boolean {
  const stored = readStorageOverride()
  if (stored !== undefined) {
    return stored
  }
  const envOverride = readEnvOverride()
  if (envOverride !== undefined) {
    return envOverride
  }
  return environment.isDev
}
